<script>
import { HorizontalBar } from 'vue-chartjs'
import API from '@/api/log'
import moment from 'moment'
import Customer from '@/utils/customer'

export default {
  extends: HorizontalBar,
  mixins: [Customer],
  data() {
    return {
      accessCountsByAge: { }
    }
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [{
          label: this.$t('Analysis.User.male'),
          backgroundColor: '#009CE1',
          data: this.getDataForGender('male')
        },{
          label: this.$t('Analysis.User.female'),
          backgroundColor: '#99D7F3',
          data: this.getDataForGender('female')
        },{
          label: this.$t('Analysis.User.other'),
          backgroundColor: '#BDEDFF',
          data: this.getDataForGender('other')
        }]
      };
    },
    labels() {
      return this.getAgeLabelsInOrder();
    }
  },
  mounted() {
    this.options = {
      datalabels: {
        align: 'end',
        anchor: 'end',
        color: function(context) {
          return context.dataset.backgroundColor;
        },
        font: function(context) {
          var w = context.chart.width;
          return {
            size: w < 512 ? 12 : 14
          }
        }
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: "#999"
          }
        }],
        xAxes: [{
          ticks: {
            display: true,
            min: 0
          },
          beforeFit: function (scale) {
            let maxValue = 0
            scale.chart.config.data.datasets.forEach(dataset => {
              if (dataset && dataset.data) {
                dataset.data.forEach(value => {
                  if (value > maxValue) {
                    maxValue = value
                  }
                })
              }
            })
            scale.options.ticks.max = maxValue + 2
          }
        }]
      },
      plugins: {
        datalabels: {
          display: true,
          align: 'end',
          anchor: 'end',
          color: '#AAA',
          font: function(context) {
            return {
              size: 10
            }
          }
        }
      },
      tooltips: {
        filter: function(tooltip) {
          return tooltip.value !== 'NaN'
        }
      }
    };
    this.$emit('counts-updated', !this.checkEmpty());
    this.updateChartData();
  },
  methods: {
    getDataForGender: function(gender) {
      // console.log(gender, this.getAgesInOrder().map(a => (this.accessCountsByAge[a]||{})[gender]))
      return this.getAgesInOrder().map(a => (this.accessCountsByAge[a]||{})[gender]);
    },
    checkEmpty: function()
    {
      return Object.values(this.accessCountsByAge).every(v => Object.keys(v).length === 0)
    },
    checkHaveData: function () {
      this.options.plugins.datalabels.display = !this.checkEmpty();
    },
    updateChartData: function() {
      const that = this;
      const reqParams = {
        date: moment().format('YYYY-MM-DD')
      };
      API.getAccessCountsByAge(reqParams).then(function(response) {
        if (response && response.access_counts_by_age) {
          that.accessCountsByAge = response.access_counts_by_age;
        } else {
          that.accessCountsByAge = { };
        }
      });
    },
    renderWithChecks() {
      this.checkHaveData();
      this.renderChart(this.chartData, this.options);
    }
  },
  watch: {
    accessCountsByAge() {
      this.$emit('counts-updated', !this.checkEmpty());
      this.renderWithChecks();
    }
  }
}
</script>
